import { useContext } from 'react';
import { MenuBalanceContext } from 'moduleBase/modules/menu-balance/contexts/menu-balance-context';

var useMenuBalanceContext = function useMenuBalanceContext() {
  return useContext(MenuBalanceContext);
};

export { useMenuBalanceContext };